<div class="wrapper wrapper-full-page">
  <div class="page-header login-page">
    <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
          <div class="text-center">
            <img style="max-width: 150px;height: auto;" src="./assets/img/logo.jpeg">
          </div>
          <form [formGroup]="form" (ngSubmit)="forgot()">
            <div class="card card-login card-hidden">
              <div class="card-body ">
                <h3 class="card-description text-center mt-4 mb-4">Mot de passe oublié</h3>
                <p class="card-description text-center connexion">Mot de passe oublié</p>

                <div class="content">
                  <div class="form-group">
                    <label class="form-label">Adresse email</label>
                    <input type="email" class="form-control" formControlName="email" placeholder="Entrer votre email">
                  </div>
                </div>
              </div>

              <div class="card-footer justify-content-center">
                <button type="submit" class="btn btn-danger btn-fill">Recevoir un nouveau mot de passe</button>
              </div>
              <div class="card-footer justify-content-center mb-3">
                <a [routerLink]="['/auth', 'login']" class="link">Revenir vers l'identification</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
